export default __webpack_public_path__ + "static/media/dotT.57ac673b.png";